export const baseTaxonomy = `
    tid,
    status,
    name,
    weight
`;

export const baseWaterProviderTaxonomy = `
    ${baseTaxonomy},
    adminId
`;

export const baseCategoryTaxonomy = `
    ${baseTaxonomy},
    adminId
`;

export const baseCategoryChartTaxonomy = `
    ${baseTaxonomy},
    className,
    displayTitle {
        value,
        format,
        processed
    },
    visType,
    visGroup,
    adminId,
    visibilityFn,
    paramFetchFn,
    queryFn,
    figureHeader {
        value,
        format,
        processed
    },
    figureFooter {
        value,
        format,
        processed
    },
    visHeader {
        value,
        format,
        processed
    },
    visFooter {
        value,
        format,
        processed
    }
`;

export const baseContent = `
    nid,
    status,
    title
`;

export const baseGraphicElementContent = `
    ${baseContent},
    adminId
`;

export const baseDynamicPageContent = `
    ${baseContent},
    adminId
`;

export const baseParagraphContent = `
    ${baseContent},
    adminId
`;

export const baseKpiReportTemplateContent = `
    ${baseContent},
    displayTitle,
    visGroup
`;

export const baseReactContent = `
    ${baseContent},
    adminId
`;

export const baseCategoryDescriptionTaxonomy = `
    ${baseTaxonomy},
    description {
        value,
        format,
        processed
    },
    category {
        ${baseCategoryTaxonomy}    
    }
`;
